import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift } from 'lucide-react';
export function BonusSection() {
  return <section className="py-20 bg-cream-dark" data-id="element-13">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-14">
        <FadeIn data-id="element-15">
          <div className="bg-white rounded-3xl overflow-hidden shadow-xl border border-gold/20" data-id="element-16">
            <div className="flex flex-col md:flex-row" data-id="element-17">
              {/* Image */}
              <div className="md:w-2/5 relative" data-id="element-18">
                <img src="https://cdn.magicpatterns.com/uploads/nvDJxB8hUKGVm9j22c11hb/bono_pic.png" alt="Suplementos naturales para perimenopausia" className="w-full h-full object-cover min-h-[280px]" data-id="element-19" />
                <div className="absolute top-4 left-4 bg-gold text-forest font-bold text-xs uppercase tracking-wider px-3 py-1.5 rounded-full flex items-center gap-1.5 shadow-md" data-id="element-20">
                  <Gift className="w-3.5 h-3.5" data-id="element-21" />
                  Bono incluido
                </div>
              </div>

              {/* Content */}
              <div className="md:w-3/5 p-8 md:p-10 flex flex-col justify-center" data-id="element-22">
                <span className="text-gold font-bold text-sm uppercase tracking-widest mb-3" data-id="element-23">
                  Bono Especial
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-forest mb-4 leading-tight font-heading" data-id="element-24">
                  Guía de Apoyo — Suplementos Naturales en Perimenopausia
                </h2>
                <p className="text-forest/60 font-medium text-lg mb-4 italic" data-id="element-25">
                  El complemento estratégico para tu Protocolo de Sincronía
                  Hormonal.
                </p>
                <div className="w-16 h-0.5 bg-sage mb-5 rounded-full" data-id="element-26"></div>
                <p className="text-forest/70 leading-relaxed" data-id="element-27">
                  Esta guía no reemplaza tu alimentación ni tu consulta médica;
                  es el "acelerador" de tus resultados. Después de los 40, el
                  cuerpo a veces necesita una señal química extra para salir del
                  estado de alerta (cortisol alto) y entrar en modo
                  recuperación. Aquí tienes la selección basada en evidencia
                  para los desafíos más comunes de esta etapa.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}